import { render, staticRenderFns } from "./patientList.vue?vue&type=template&id=4c74960e&scoped=true&"
import script from "./patientList.vue?vue&type=script&lang=js&"
export * from "./patientList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c74960e",
  null
  
)

export default component.exports